<script setup lang="ts">
const baseAnimationClass = 'trasistion duration-200'
const enterFormClass = 'scale-[0.1] opacity-0'
const leaveToClass = 'scale-[0.1] opacity-0'
const enterToClass = 'scale-100 opacity-1'
const leaveFormClass = 'scale-100 opacity-1'
</script>

<template>
    <Transition mode="out-in" :enter-active-class="baseAnimationClass" :enter-from-class="enterFormClass"
        :enter-to-class="enterToClass" :leave-active-class="baseAnimationClass" :leave-from-class="leaveFormClass"
        :leave-to-class="leaveToClass">
        <slot />
    </Transition>
</template>